module.exports = __webpack_public_path__ + "media/images/Ciratas_PrimaryLogo-1691446ec64c96299813d266ac48a1be.png";